export default __webpack_public_path__ + "static/media/Tabela_Descontos_Formato.0a9cb4c9.pdf";